import { E164Number, parsePhoneNumberWithError } from 'libphonenumber-js';

export default class PhoneNumber {
  public static fromJSON(value: string | null | undefined): PhoneNumber | null | undefined {
    return value === null || value === undefined ? value :
      new PhoneNumber(value);
  }

  public constructor(public readonly value: string | E164Number) {}
  
  public toJSON(): string { 
    return this.value 
  }

  public toE164Number(): E164Number {
    return parsePhoneNumberWithError(this.value).number;
  }

  public isEqualTo(other: PhoneNumber | null | undefined): boolean {
    if (!other) return false;
    return this.toE164Number() === other.toE164Number();
  }

  public toString(): string {
    return `PhoneNumber (value: ${this.value})`;
  }
}
